<div class="mb-3 mt-3">
  <label class="form-label fw-bold">Select Date Range:</label>
  <div class="d-flex gap-2 width-50">
    <input type="date" class="form-control" [(ngModel)]="filter.fromDate">
    <input type="date" class="form-control" [(ngModel)]="filter.toDate">
    <button class="btn btn-primary" (click)="filterByDate()">Search</button>
  </div>
</div>

<div class="card-body table-container">
  <table class="table table-bordered mt-3" *ngIf="summaryList.length > 0">
    <thead>
      <tr>
        <th>Master Account ID</th>
        <th>Stage</th>
        <th>Sub Stage</th>
        <th>Status</th>
        <th>Start Time</th>
        <th>End Time</th>
        <th>Duration (sec)</th>
        <th>Duration (min)</th>
        <th>Last Updated</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of summaryList">
        <td>{{ item.master_account_id }}</td>
        <td>{{ item.stage }}</td>
        <td>{{ item.sub_stage }}</td>
        <td>
          <span [ngClass]="{
            'text-success': item.status === 'SUCCESS',
            'text-danger': item.status === 'FAILED',
            'text-warning': item.status === 'IN_PROGRESS'
          }" class="fw-bold">
            {{ item.status }}
          </span>
        </td>
        <td>{{ item.start_time | date: 'medium' }}</td>
        <td>{{ item.end_time | date: 'medium' }}</td>
        <td>{{ item.duration_seconds }}</td>
        <td>{{ item.duration_seconds }}</td>
        <td>{{ item.last_updated | date: 'medium' }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div *ngIf="dataLoaded && summaryList.length === 0" class="text-danger fw-bold mt-3">
  No data found for selected date range.
</div>